import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './ProductCard.module.scss';

type ProductCardProps = {
  imageUrl: string,
  description: any,
  tailing: any,
  id: number,
  shadow?: boolean
  hasLink?: boolean | false
}

const ProductCard: FC<ProductCardProps> = ({
  imageUrl,
  description,
  tailing,
  id,
  shadow,
  hasLink,
}) => (
  <>
    {
      hasLink
        ? (
          <Link to={`/product-details/${id}`} className={styles.link}>
            <div
              className={`${styles.card} ${shadow && styles.shadow}`}
            >
              <img className={styles.cardImage} src={imageUrl} alt="" />
              <div className={styles.details}>
                <div className={styles.productName}>
                  {description}
                </div>

                <div className={styles.productPrice}>
                  {tailing}
                </div>
              </div>
            </div>
          </Link>
        )
        : (
          <div
            className={`${styles.card} ${shadow && styles.shadow}`}
          >
            <img className={styles.cardImage} src={imageUrl} alt="" />
            <div className={styles.details}>
              <div className={styles.productName}>{description}</div>
              <div className={styles.productPrice}>
                {tailing}
              </div>
            </div>
          </div>
        )
    }
  </>
);

export default ProductCard;
